<template>
    <v-dialog v-model="$store.state.report.preventive" width="1200px">
        <v-container grid-list-xs fluid >
            <v-card>
                <v-toolbar dark color="primary" dense>
                    <v-spacer></v-spacer>
                    <h3>Preventive Errors Report</h3>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="$store.state.report.preventive = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-container grid-list-xs fluid>
                    <v-row>
                        <v-col cols="3">
                            <v-data-table
                                :headers="totals"
                                :items="data['totals']"
                                disable-items-per-page
                                disable-pagination
                                dense
                                style="min-height:400px;"
                                hide-actions
                                hide-default-footer
                                @click:row="changeFilter"
                            >
                            </v-data-table>
                            <template v-slot:items="props">
                            <tr @click="changeFilter(props.item)">
                                <td>{{ props.item.User }}</td>
                                <td>{{ props.item.Total }}</td>
                                <!-- Other table cells -->
                            </tr>
                            </template>
                            <!-- <template v-slot:item.User="x">
                                <div @click="changeFilter(x)">
                                    
                                </div>
                            </template> -->
                        </v-col>
                        <v-col>
                            <v-data-table
                                :headers="details"
                                :items="filteredItems"
                                dense
                                hide-actions
                            >
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-container>
    </v-dialog>
</template>
<script>
export default {
    props: ['data', 'report'],
    data: function() {
        return {
            filter:null,
            totals:[
                { text: 'User', value: 'User' },
                { text: 'Total', value: 'Total' },
            ],
            details:[
                { text: 'Order', value: 'Order' },
                { text: 'name', value: 'name' },
                { text: 'From', value: 'From' },
                { text: 'Error', value: 'Date' },
            ]
        };
    },
    computed: {
        filteredItems() {
            return this.data['details'].filter(i => {
                return !this.filter || i.name == this.filter;
            });
        }
    },
    async mounted() {
        console.log(this.data);
    },
    methods:{
        changeFilter: function(itm){
            this.filter = itm.User;
            console.log(this.filter);
        }
    }
    

};
</script>
<style>
.tblLogs {
    width: 100%;
}
</style>
